import { SessionService } from 'app/core/services/session.service';
import { GlobalValidators } from 'app/core/components/common/validators';
import { DateUtils } from 'app/core/components/common/date-utils';
import { StringUtils } from 'app/core/components/common/string-utils';
import { ExamInfo, Exam } from 'app/solar/common/exam';
import { ReactiveInputComponent } from 'app/shared/components/reactive-input/reactive-input.component';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChange, Type, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { NotificationService } from 'app/core/services/notification.service';
import { ClassesService } from 'app/solar/common/services/classes.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { FlexibleDropdownConfig } from 'app/shared/components/flexible-dropdown/flexible-dropdown.component';
import { AddressService } from 'app/solar/common/services/address.service';
import { ContactService } from '../services/contact.service';
import { AddInstructorComponent } from 'app/solar/common/add-instructor/add-instructor.component';
import { InstructorSelectEvent, InstructorsLoadEvent } from 'app/solar/classes/components/wizard/class-instructor/class-instructor.component';
import { EditInstructorComponent } from 'app/solar/classes/components/wizard/class-instructor/edit-instructor/edit-instructor.component';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';


declare var $: any;
declare var moment: any;

@Component({
    selector: 'itpx-exam-info',
    templateUrl: './exam-info.component.html',
    styleUrls: ['./exam-info.component.css']
})
export class ExamInfoComponent extends RxComponent {

    private turnaroundTime: number;
    private examMinDate: Date;
    private classInfo: FormGroup;
    private addressConfig: any;
    private proctorConfig: any;
    private personConfig: any;
    private buyerLogoPath: string;
    private buyerName: string;
    // private hasCertificate: boolean;
    private addClick = new Subject<string>();
    private editClick = new Subject<string>();
    private placeholderDropdown = 'Select up to 3 signatories';
    private instructorsPerGroups: Observable<any>;
    private instructorsAll: Observable<any>;
    private instructorSelect = new Subject<InstructorSelectEvent>();
    private productGroups: Observable<any[]>;
    private editClass: Boolean = false;
    private timezones: Observable<any[]>;
    private examsInSessionInfo: any[];

    @ViewChild('startDate') startDateElement: ReactiveInputComponent;
    @ViewChild('endDate') endDateElement: ReactiveInputComponent;
    // @ViewChild('examDate') examDateElement: ReactiveInputComponent;
    // @ViewChild('examTime') examTimeElement: ReactiveInputComponent;

    @Input() private class: any;
    @Input() private config: any;
    @Input() private status: string;
    @Input() private maxTurnaroundTime: Observable<number>;
    @Input() private forceVenueListRefresh: Observable<any>;
    @Input() private disabled: boolean = false;
    @Input() private policies: any;
    @Input() private examsInSession: any[] = null;


    @Output() private formStateChange = new EventEmitter<any>();

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private notificationService: NotificationService,
        private classesService: ClassesService,
        private addressService: AddressService,
        private sessionService: SessionService,
        private contactService: ContactService,
        private modalService: SmartModalService
    ) {
        super();
    }

    ngOnInit() {

        let classData = this.getInitialExamInfo();
        if (this.class)
            this.policies = this.class.hasOwnProperty('productVariants') && this.class.productVariants.length > 0 ? this.class.productVariants[0].policies : {};
        this.personConfig = this.contactService.getClassExamContactPersonFlexConfig();
        this.personConfig.required = this.getPolicy('contact', 'email_phone', 'mandatory');
        this.proctorConfig = this.contactService.getClassExamProctorFlexConfig();
        this.proctorConfig.required = this.getPolicy('proctor', 'email_phone', 'mandatory');
        let examId, examVenueId;
        if (this.class) {
            let exam = this.getExam(this.class.exams);
            this.examsInSession = Object.keys(this.class.exams).map(key => this.class.exams[key]);
            examId = exam.id;
            examVenueId = exam.address && exam.address.id;
        }
        this.addressConfig = this.addressService.getClassExamVenueFlexConfig(
            this.class ? this.class.id : null,
            examId,
            this.forceVenueListRefresh
        );
        this.addressConfig.initialItem = { key: examVenueId };
        this.addressConfig.label = 'Exam Venue';
        this.addressConfig.required = this.getPolicy('exam', 'venue', 'mandatory');
        this.productGroups = Observable.of(this.examsInSession.map(e => this.status === 'create' ? e.agoraProductVariant.product.group : e.productVariant.product.group)).shareReplay();
        let groupIds = (this.examsInSession.map(e => this.status === 'create' ? e.agoraProductVariant.product.group.id : e.productVariant.product.group.id));

        let instructorAdded = this.addClick
            .flatMap(groupId => this.modalService.open(<Type<Component>>AddInstructorComponent, null, 'Add New Instructor')
                .map(res => new InstructorSelectEvent(groupId, res.result, false))
                .neverError()
            )
            .shareReplay();
        let instructorEdited = this.editClick
            .flatMap(groupId => this.modalService.open(<Type<Component>>EditInstructorComponent,
                { id: this.class ? this.class.id : null, groupId: groupId }, 'Manage Instructors', ModalSize.Lg)
                .catchAndEmit(new InstructorsLoadEvent(groupId, null)))
            .shareReplay();
        instructorAdded
            .bindToLifecycle(this)
            .subscribe(instructor => {
                this.classInfo.controls.instructorId.setValue(instructor.instructorId);
                this.notificationService.success('Class instructor added.');
            });

        // console.log(this.examsInSession.map(e => e.product.group.id));

        let instructorsLoaded = Observable.merge(instructorAdded, instructorEdited, Observable.of(true))
            // Emit every product group
            // .flatMap(_ => Observable.from(this.examsInSession.map(e => this.status === 'create' ? e.agoraProductVariant.product.group.id : e.productVariant.product.group.id)))
            // Fetch instructor lists
            .flatMap(_ => {
                return this.classesService.getAccreditedInstructors(groupIds.join('&@productGroupId='))
                    .map(body => { return new InstructorsLoadEvent(groupIds[0], body.data) })
                    .catchAndEmit(new InstructorsLoadEvent(groupIds[0], null));
            }
            )
            .share();
        let instructorSelected = Observable.merge(this.instructorSelect, instructorAdded.takeWhen(instructorsLoaded))
            .shareReplay();

        this.instructorsPerGroups = Observable.merge(instructorsLoaded, instructorSelected)
            .scan((total, event) => {
                if (event instanceof InstructorsLoadEvent) {
                    let savedInstructor = null;
                    let classInstructor = null;
                    let isVirtual = false;
                    if (this.class && this.class.instructors[event.groupId]) {
                        classInstructor = this.class.instructors[event.groupId].instructor;
                        isVirtual = this.class.instructors[event.groupId].virtual;
                    }

                    if (classInstructor) {
                        savedInstructor = { key: classInstructor.id, value: classInstructor.username };
                    }
                    let current = total[event.groupId] ? total[event.groupId].current : savedInstructor;
                    if (current && event.instructors.filter(entry => entry.key == current.key).length == 0) {
                        current = null;
                    }
                    total[event.groupId] = {
                        current: current,
                        virtual: isVirtual,
                        all: event.instructors
                    };
                } else if (event instanceof InstructorSelectEvent) {
                    total[event.groupId].virtual = event.virtual;
                    if (event.instructorId) {
                        total[event.groupId].current = total[event.groupId].all.find(i => i.key == event.instructorId);
                    }
                }
                return total;
            }, {})
            .startWith({})
            .shareReplay();
        this.instructorsAll = this.instructorsPerGroups.flatMap(r => Object.keys(r).map(k => { return { all: r[k].all, current: r[k].current } }));
        this.classInfo = this.fb.group({
            id: [classData.id],
            displayName: [{ value: classData.displayName, disabled: this.disabled }, [Validators.required, Validators.minLength(2)]],
            // examDate: [{ value: classData.examDate, disabled: this.disabled || !this.getPolicy('exam', 'date_time', 'required') },
            // this.getPolicy('exam', 'date_time', 'mandatory') ? [Validators.required] : []],
            startDate: [{ value: classData.startDate, disabled: this.disabled || !this.getPolicy('class', 'dates', 'required') },
            this.getPolicy('class', 'dates', 'mandatory') ? [Validators.required] : []],
            endDate: [{ value: classData.endDate, disabled: this.disabled || !this.getPolicy('class', 'dates', 'required') },
            this.getPolicy('class', 'dates', 'mandatory') ? [Validators.required] : []],
            // examTime: [{ value: null, disabled: this.disabled || !this.getPolicy('exam', 'date_time', 'required') },
            // this.getPolicy('exam', 'date_time', 'mandatory') ? [Validators.required] : []],
            proctorId: [{ value: classData.proctorId, disabled: this.disabled || !this.getPolicy('proctor', 'email_phone', 'required') },
            this.getPolicy('proctor', 'email_phone', 'mandatory') ? [Validators.required] : []],
            personId: [{ value: classData.personId, disabled: this.disabled || !this.getPolicy('contact', 'email_phone', 'required') },
            this.getPolicy('contact', 'email_phone', 'mandatory') ? [Validators.required] : []],
            venueId: [{ value: classData.venueId, disabled: this.disabled || !this.getPolicy('exam', 'venue', 'required') },
            this.getPolicy('exam', 'venue', 'mandatory') ? [Validators.required] : []],
            instructorGuidedExam: [{ value: !!classData.instructorGuidedExam, disabled: this.disabled }],
            timezone: [{ value: classData.timezone, disabled: this.disabled || !this.getPolicy('exam', 'date_time', 'required') },
            this.getPolicy('exam', 'date_time', 'mandatory') ? [Validators.required] : []],
            productVariantId: [{ value: classData.productVariantId, disabled: this.disabled }],
            instructorId: [{ value: classData.instructorId, disabled: this.disabled || !this.getPolicy('instructor', 'name_email', 'required') },
            this.getPolicy('instructor', 'name_email', 'mandatory') ? [Validators.required] : []],
            groupId: [{ value: classData.groupId, disabled: this.disabled }],
            releaseDate: [{ value: classData.releaseDate, disabled: this.disabled }],
            classTimeZone: [{ value: classData.classTimeZone, disabled: this.disabled }],
            additionalInfo: [{ value: classData.additionalInfo, disabled: this.disabled }]
        });
        let startDate = this.classInfo.controls.startDate.valueChanges
            .filter(d => StringUtils.notNullOrEmpty(d))
            .startWith(classData.startDate);

        let endDate = this.classInfo.controls.endDate.valueChanges
            .filter(d => StringUtils.notNullOrEmpty(d))
            .startWith(classData.endDate);

        // let examDate = this.classInfo.controls.examDate.valueChanges
        //     .filter(d => StringUtils.notNullOrEmpty(d))
        //     .startWith(classData.examDate);


        startDate
            .map(val => new Date(val))
            .bindToLifecycle(this)
            .subscribe(startDate => {
                this.endDateElement.set('minDate', startDate);

                let maxReleaseDate = startDate;
                if (this.status == 'edit') {
                    let exams = Object.keys(this.class.exams);
                    if (exams.length > 0) {

                        let minExamDate = exams
                            .map(variantSku => this.getExamTurnAroundTimeStartDate(this.class.exams[variantSku]))
                            .reduce((d1, d2) => d1.isBefore(d2) ? d1 : d2);

                        if (moment(startDate).isAfter(minExamDate)) {
                            maxReleaseDate = minExamDate._d;
                        }
                    }
                }
            });

        this.editClass = !!classData.instructorGuidedExam;

        let today = moment().startOf('day')._d;
        let tomorrow = moment().startOf('day').add(1, 'days')._d;
        let now = moment()._d;


        switch (this.status) {
            case 'create':
                this.startDateElement.set('minDate', tomorrow);
                this.endDateElement.set('minDate', tomorrow);
                // this.examDateElement.set('minDate', tomorrow);
                //this.classInfo.controls.examTime.setValue('12:00');
                // this.maxTurnaroundTime
                //     .bindToLifecycle(this)
                //     .subscribe(turnaround => {
                //         // let turnAroundTimeDays = turnaround / 24;
                //         this.turnaroundTime = turnaround || 72;
                //         this.examMinDate = moment().startOf('day').add(this.turnaroundTime / 24, 'days')._d;
                //         let examTimeStr = moment().add(10, 'minute').format('HH:mm');
                //         this.classInfo.controls.examTime.setValue(examTimeStr);
                //         // this.examDateElement.set('minDate', this.examMinDate);
                //     });
                break;
            case 'edit':
                this.startDateElement.set('minDate', moment(this.class.startDate)._d);
                this.endDateElement.set('minDate', moment(this.class.startDate)._d);
                // this.examDateElement.set('softMinDate', moment(this.class.examDate)._d);
                // let examTimeStr = moment(classData.examDate).format('HH:mm');
                // this.classInfo.controls.examTime.setValue(examTimeStr);
                // this.maxTurnaroundTime
                //     .bindToLifecycle(this)
                //     .subscribe(turnaround => {
                //         // let turnAroundTimeDays = turnaround / 24;
                //         this.turnaroundTime = turnaround;
                //         this.examMinDate = moment(classData.releaseDate).startOf('day').add(this.turnaroundTime / 24, 'days')._d;
                //     });
                break;
        }
        this.classInfo.controls.instructorGuidedExam.valueChanges
            .startWith(this.classInfo.controls.instructorGuidedExam.value)
            .bindToLifecycle(this)
            .subscribe(toggled => {
                this.editClass = toggled;
                /*if (toggled) {
                    this.classInfo.controls.startDate.enable();
                    this.classInfo.controls.endDate.enable();
                } else {
                    this.classInfo.controls.startDate.disable();
                    this.classInfo.controls.endDate.disable();
                }*/
            });

        Observable.combineLatest(
            startDate, endDate,
            (start, end) => ({ start: start, end: end })
        )
            .skip(1)
            .bindToLifecycle(this)
            .subscribe(dates => {
                if (moment(dates.start).diff(moment(dates.end), 'days') >= 1) {
                    this.classInfo.controls.endDate.setErrors({ msg: 'End date must be after start date.' });
                    this.classInfo.controls.endDate.markAsTouched();
                }
            });
        this.timezones = this.classesService.getTimezonesDictionary()
            .map(body => body.data)
            .neverError();

        this.classInfo.statusChanges
            .bindToLifecycle(this)
            .subscribe(status => {
                this.formStateChange.emit({ valid: status == 'VALID', dirty: this.classInfo.dirty, data: this.getFormData() });
            });

        this.instructorSelect.subscribe(
            event => {
                this.classInfo.controls.instructorId.setValue(event.instructorId);
                this.classInfo.markAsDirty();
            }
        )
    }

    private onNewAddress() {
        this.formStateChange.emit({ type: 'address' });
    }

    private onNewContact() {
        this.formStateChange.emit({ type: 'contact' });
    }
    private getExamTurnAroundTimeStartDate(exam: any): any {
        return moment(exam.fulfillmentDeadlineDate).startOf('day');
    }

    private getFormData(): ExamInfo {
        let formData = this.classInfo.getRawValue();
        formData.examDate = moment(formData.examDate).startOf('day')._d;
        formData.startDate = formData.startDate == null || '' === formData.startDate ? null : this.toLocalTime(moment(formData.startDate).startOf('day')._d);
        formData.endDate = formData.endDate == null || '' === formData.endDate ? null : this.toLocalTime(moment(formData.endDate).startOf('day')._d);
        formData.releaseDate = this.toLocalTime(moment().startOf('day')._d);
        let [hours, minutes] = formData.examTime && formData.examTime != '' ?
            formData.examTime.split(':') :
            moment(formData.examDate).format('HH:mm').split(':');

        formData.examDate = this.toLocalTime(formData.examDate, parseInt(hours, 10), parseInt(minutes, 10));
        formData.examDatesInSession = this.examsInSession.map(e => { return { id: this.status === 'create' ? e.productId : e.productVariant.id, date: e.date } })


        return formData;
    }

    private getInitialExamInfo(): ExamInfo {

        return {
            id: this.class ? this.class.id : null,
            name: this.class ? this.class.name : null,
            displayName: this.class ? this.class.displayName : null,
            examDate: this.class && this.class.exams ? this.getDate(this.class.exams) : null,
            examTime: this.class && this.class.exams ? this.getDate(this.class.exams) : null,
            virtualVenue: this.class ? this.class.virtualVenue : false,
            proctorId: this.class && this.class.exams && this.getExam(this.class.exams).proctor ? this.getExam(this.class.exams).proctor.id : null,
            personId: this.class && this.class.exams && this.getExam(this.class.exams).contactPerson ? this.getExam(this.class.exams).contactPerson.id : null,
            venueId: this.class && this.class.exams && this.getExam(this.class.exams).address ? this.getExam(this.class.exams).address.id : null,
            timezone: (this.class && this.class.exams) ? this.getExam(this.class.exams).timeZone : moment.tz.guess(),
            instructorGuidedExam: this.class && null !== this.class.selfPacedClass ? !this.class.selfPacedClass : false,
            startDate: this.class ? this.class.startDate : null,
            endDate: this.class ? this.class.endDate : null,
            productVariantId: this.class && this.class.productVariants.length > 0 ? this.class.productVariants[0].id : null,
            groupId: this.class && this.class.productGroups && this.class.productGroups.length > 0 ? this.class.productGroups[0].id : null,
            instructorId: this.class && this.class.instructorCount > 0 && this.class.instructors && Object.keys(this.class.instructors).length > 0 &&
                this.class.productGroups && this.class.productGroups.length > 0 &&
                this.class.instructors[this.class.productGroups[0].id].instructor ? this.class.instructors[this.class.productGroups[0].id].instructor.id : null,
            releaseDate: this.class ? this.class.releaseDate : null,
            classTimeZone: this.class ? this.class.timezone : null,
            additionalInfo: this.class && this.class.exams ? this.getExam(this.class.exams).additionalInfo : null
        };
    }

    private getDate(item: any) {
        return item[Object.keys(item)[0]].date;
    }

    private getExam(item: any) {
        return item[Object.keys(item)[0]];
    }

    private toLocalTime(date: any, hours?: number, minutes?: number): string {
        let mDate = moment(date);
        if (hours >= 0 && minutes >= 0) {
            mDate.set({ hour: hours, minute: minutes });
        }

        return moment(mDate).utc().add(mDate.utcOffset(), 'm').format();
    }

    private onInstructorAddClick(groupId: string) {
        this.addClick.next(groupId);
    }

    private onInstructorEditClick(groupId: string) {
        this.editClick.next(groupId);
    }

    private onInstructorSelect(groupId: string, instructorId: any) {
        this.instructorSelect.next(new InstructorSelectEvent(groupId, instructorId, false));
    }

    private getPolicy(key: string, key2: string, key3: string) {
        if (this.policies && this.policies.hasOwnProperty(key) && this.policies[key].hasOwnProperty(key2) && this.policies[key][key2].hasOwnProperty(key3))
            return this.policies[key][key2][key3];
        return true;
    }

    private onFormStateChange(state: any) {
        this.examMinDate = state.data.examMinDate;
        if (this.status === 'edit') {
            if (this.examsInSession.filter(e => e.id === state.data.id)[0]) {
                this.examsInSession.filter(e => e.id === state.data.id)[0].date = state.data.examDate;
                this.formStateChange.emit({ valid: state.valid, dirty: state.dirty, data: this.getFormData() });
            }
        }
        else {
            if (this.examsInSession.filter(e => e.productId === state.data.id)[0]) {
                this.examsInSession.filter(e => e.productId === state.data.id)[0].date = state.data.examDate;
                this.formStateChange.emit({ valid: state.valid, dirty: state.dirty, data: this.getFormData() });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/solar/common/exam-info/exam-info.component.ts